webpackJsonp([24],{

/***/ 1113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationsBulkEmail_vue__ = __webpack_require__(1264);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01cd8f3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationsBulkEmail_vue__ = __webpack_require__(1400);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationsBulkEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01cd8f3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationsBulkEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__ = __webpack_require__(75);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FTextarea',
  components: {
    FGroup: __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__["a" /* default */]
  },
  props: {
    value: {
      default: ''
    },
    label: String,
    id: {
      type: String,
      required: true
    },
    rows: {
      default: 3
    },
    required: Boolean,
    placeholder: String,
    tooltip: String,
    error: {
      type: String,
      default: null
    }
  }
});

/***/ }),

/***/ 1133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FTextarea_vue__ = __webpack_require__(1128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dfa61c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FTextarea_vue__ = __webpack_require__(1134);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dfa61c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-group',{attrs:{"label":_vm.label,"id":_vm.id,"required":_vm.required,"tooltip":_vm.tooltip,"error":_vm.error}},[_c('textarea',{class:['form-control', _vm.error && 'is-invalid'],attrs:{"id":_vm.id,"rows":_vm.rows,"required":_vm.required,"placeholder":_vm.placeholder,"autocomplete":"off"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FSearchSelect__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormFields_FTextarea__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__composables_nominations_useNominationsBulkEmail__ = __webpack_require__(1399);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'NominationsBulkEmail',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_3__components_AppButton__["a" /* default */],
    FSearchSelect: __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FSearchSelect__["a" /* default */],
    FTextarea: __WEBPACK_IMPORTED_MODULE_5__components_FormFields_FTextarea__["a" /* default */]
  },
  setup: function setup() {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var draftId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return proxy.$route.params.draftId;
    });
    var bulkEmail = Object(__WEBPACK_IMPORTED_MODULE_6__composables_nominations_useNominationsBulkEmail__["a" /* default */])(draftId.value);
    var form = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({
      sendType: null,
      sendTo: null,
      text: ''
    });

    function handleSend() {
      return _handleSend.apply(this, arguments);
    }

    function _handleSend() {
      _handleSend = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(form.sendType == null || form.sendTo == null || !form.text)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return bulkEmail.send({
                  send_type: form.sendType,
                  send_to: form.sendTo,
                  bulk_text: form.text
                });

              case 4:
                result = _context.sent;

                if (result != null) {
                  form.sendType = null;
                  form.sendTo = null;
                  form.text = '';
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _handleSend.apply(this, arguments);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      bulkEmail.fetchOptions();
    });
    return {
      form: form,
      sendTypes: bulkEmail.sendTypes,
      recipients: bulkEmail.recipients,
      sending: bulkEmail.sending,
      handleSend: handleSend
    };
  }
}));

/***/ }),

/***/ 1399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useNominationsBulkEmail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__ = __webpack_require__(437);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useNominationsBulkEmail(draftId) {
  var sendTypes = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var recipients = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var sending = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var optionsLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function fetchOptions() {
    return _fetchOptions.apply(this, arguments);
  }

  function _fetchOptions() {
    _fetchOptions = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              optionsLoading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].bulkMessageOptions(draftId);

            case 4:
              res = _context.sent;
              data = res.data.data != null ? res.data.data : {};
              sendTypes.value = data.sendTypes != null ? data.sendTypes : [];
              recipients.value = data.recipients != null ? data.recipients : [];
              _context.next = 12;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);

            case 12:
              optionsLoading.value = false;

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));
    return _fetchOptions.apply(this, arguments);
  }

  function send(_x) {
    return _send.apply(this, arguments);
  }

  function _send() {
    _send = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(data) {
      var res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              sending.value = true;
              _context2.prev = 1;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].bulkMessage(draftId, data);

            case 4:
              res = _context2.sent;
              return _context2.abrupt("return", res.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              return _context2.abrupt("return", null);

            case 11:
              _context2.prev = 11;
              sending.value = false;
              return _context2.finish(11);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8, 11, 14]]);
    }));
    return _send.apply(this, arguments);
  }

  return {
    sendTypes: sendTypes,
    recipients: recipients,
    sending: sending,
    optionsLoading: optionsLoading,
    fetchOptions: fetchOptions,
    send: send
  };
}

/***/ }),

/***/ 1400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"bg-white rounded mb-4 p-3",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('page-heading',[_vm._v("Send bulk email/text")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.handleSend($event)}}},[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12 col-md-6 mb-3 mb-md-0"},[_c('f-search-select',{attrs:{"id":"bulk-send-type","label":"Send Type","options":_vm.sendTypes,"option-label":"label"},model:{value:(_vm.form.sendType),callback:function ($$v) {_vm.$set(_vm.form, "sendType", $$v)},expression:"form.sendType"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('f-search-select',{attrs:{"id":"bulk-send-to","label":"Send To","options":_vm.recipients,"option-label":"label"},model:{value:(_vm.form.sendTo),callback:function ($$v) {_vm.$set(_vm.form, "sendTo", $$v)},expression:"form.sendTo"}})],1)]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('f-textarea',{attrs:{"id":"bulk-text","label":"Text","rows":6,"required":"","placeholder":"Enter your message..."},model:{value:(_vm.form.text),callback:function ($$v) {_vm.$set(_vm.form, "text", $$v)},expression:"form.text"}})],1),_vm._v(" "),_c('app-button',{attrs:{"variant":"primary","block":false,"type":"submit","loading":_vm.sending}},[_vm._v("Send")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/24.ca3fd3920cbd4f605dc2.js